document.addEventListener('click', (e) => {
  const badge = e.target.closest('[data-category-url]');
  if (!badge) return;
  e.preventDefault();
  e.stopPropagation();
  window.location.href = badge.dataset.categoryUrl;
});
